<div [innerHTML]="custom_code | sanitizeHtml"></div>
    